export default __webpack_public_path__ + "locales/sk/FormFillingTipsDialog.json?hash=77bc1c801571bc33bd72a1c7b8e4fe80";